import { useState } from 'react';

import { BiCategory, BiInfoCircle } from 'react-icons/bi';
import { HiPhone } from 'react-icons/hi';
import {
  IoBriefcaseOutline,
  IoCarSportOutline,
  IoFootballOutline,
  IoPhonePortraitOutline,
  IoShirtOutline,
} from 'react-icons/io5';
import { MdOutlineRealEstateAgent } from 'react-icons/md';
import { RiBuilding2Line, RiHomeHeartLine } from 'react-icons/ri';

import Text from '@/tayara-kit/Text';

interface Category {
  label: string;
  icon: React.ElementType<any>;
  freeAdsTotalNumber: string;
  subcategory: boolean;
  freeAdsTotalNumberdescription: string;
  subCategories?: {
    subCategoryLabel: string;
    subCategoryFreeAdsTotalNumber: string;
  }[];
}

export const FirstSectionContent = () => {
  const categories: Category[] = [
    {
      label: 'Véhicules',
      icon: IoCarSportOutline,
      freeAdsTotalNumber: '3',
      freeAdsTotalNumberdescription: ' Annonces gratuites',
      subcategory: true,
      subCategories: [
        {
          subCategoryLabel: 'Voitures',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Motos',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Pièces et Accessoires pour véhicules',

          subCategoryFreeAdsTotalNumber: '2',
        },
        {
          subCategoryLabel: 'Bateaux',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Remorques et Caravanes',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Engins Agricole',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Engins BTP',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Camions',

          subCategoryFreeAdsTotalNumber: '1',
        },
        {
          subCategoryLabel: 'Autres',

          subCategoryFreeAdsTotalNumber: '0',
        },
      ],
    },
    {
      label: 'Immobilier',
      icon: MdOutlineRealEstateAgent,
      freeAdsTotalNumber: '1',
      freeAdsTotalNumberdescription: 'Annonce gratuite',
      subcategory: false,
    },
    {
      label: 'Informatique et Multimédias',
      icon: IoPhonePortraitOutline,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Maison et jardin',
      icon: RiHomeHeartLine,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Loisirs et Divertissements',
      icon: IoFootballOutline,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Habillement et Bien Etre',
      icon: IoShirtOutline,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Emplois et Services',
      icon: IoBriefcaseOutline,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Entreprises',
      icon: RiBuilding2Line,
      freeAdsTotalNumber: '',
      freeAdsTotalNumberdescription: 'Illimitées',
      subcategory: false,
    },
    {
      label: 'Autres',
      icon: BiCategory,
      freeAdsTotalNumber: '0',
      freeAdsTotalNumberdescription: 'Annonce gratuite',
      subcategory: false,
    },
  ];

  const [showSubCategories, setShowSubCategories] = useState<boolean[]>(
    Array(9).fill(false)
  );
  const toggleSubcategories = (index: number) => {
    const updatedShowSubCategories = [...showSubCategories];
    updatedShowSubCategories[index] = !updatedShowSubCategories[index];
    setShowSubCategories(updatedShowSubCategories);
  };

  return (
    <>
      <div className="flex flex-col mx-auto justify-center items-center w-full md:w-4/6 h-fit mb-10 mt-12 md:mt-16 md:mb-16 ">
        <Text
          text="Commencez gratuitement"
          as="h3"
          className="text-2xl md:text-3xl font-bold text-center text-neutral-700"
        />
        <Text text="" as="p" />
        <p className="text-sm md:text-lg text-center text-neutral-700 mt-7">
          Inscrivez-vous et commencez à explorer tout le potentiel de{' '}
          <a
            href="https://tayara.tn"
            target={'_blank'}
            className="font-bold text-primary"
          >
            tayara.tn
          </a>
        </p>
        <Text
          text="Nombres d’annonces gratuites"
          as="h3"
          className="text-base  xl:text-2xl font-bold text-center text-neutral-700 mt-12"
        />
        <Text
          text="Limite des annonces gratuites"
          as="h4"
          className="text-xs lg:text-sm xl:text-base text-center text-neutral-700 mt-2"
        />
      </div>
      <div className="items-center flex flex-wrap gap-x-6 gap-y-6 justify-center py-8   bg-white/40 rounded-3xl outline outline-[1px] outline-dashed outline-neutral-300 ">
        {categories.map((category, index) => (
          <div
            className="flex flex-col justify-end items-center  min-w-[300px] w-fit  h-full gap-4 p-4 rounded-xl border-dashed border-[1px] border-neutral-300 shadow-sm  text-lg xl:text-xl text-center text-neutral-600 font-bold bg-white"
            key={index}
          >
            <category.icon size={50} className="text-primary" />
            <h2 className="flex text-sm lg:text-base text-center text-neutral-600 font-semibold truncate">
              {category.label}
              {category.subcategory && (
                <button
                  className="w-full flex items-center justify-center underline text-2xs lg:text-xs truncate text-neutral-800 font-normal"
                  onClick={() => toggleSubcategories(index)}
                >
                  {showSubCategories[index] ? (
                    <BiInfoCircle
                      size={16}
                      className="text-neutral-800 mt-[1px] ml-1"
                    />
                  ) : (
                    <BiInfoCircle
                      size={16}
                      className="text-neutral-800 mt-[1px] ml-1"
                    />
                  )}
                </button>
              )}
            </h2>

            <div className="relative flex items-center justify-center">
              <Text
                text={category.freeAdsTotalNumber}
                as="h2"
                className="text-lg lg:text-2xl text-center text-neutral-800 font-black"
              />
              <Text
                text={category.freeAdsTotalNumber}
                as="h2"
                className=" absolute text-6xl text-center text-neutral-100 font-black z-0"
              />
              <Text
                text={category.freeAdsTotalNumberdescription}
                as="h2"
                className="text-xs lg:text-sm px-4 py-2   text-center text-neutral-800 font-bold z-10"
              />
            </div>
            <div className="relative top-[2.5rem] right-[8.5rem]">
              {showSubCategories[index] && (
                <div className="absolute bottom-0 w-max gap-4 p-4 rounded-xl border-dashed border-[1px] border-neutral-300 shadow-lg  text-lg xl:text-xl text-center text-neutral-600 font-bold bg-white z-50">
                  <div className="flex flex-col justify-center items-center gap-x-2">
                    <Text
                      text={`Vous avez droit à ${category.freeAdsTotalNumber} annonces gratuites en totalité sous cette catégorie`}
                      as="h4"
                      className="text-xs text-center font-light text-neutral-700 my-2 w-[15rem]"
                    />
                  </div>
                  <div className="flex flex-col items-center justify-center gap-2">
                    {/* Render subcategories here */}
                    {/* {category.subCategories?.map((subCategory, subIndex) => (
                      <div
                        key={subIndex}
                        className="w-fit flex flex-col items-center justify-start gap-x-2 bg-white my-1"
                      >
                        <p className="text-sm text-neutral-600 font-bold">
                          {subCategory.subCategoryFreeAdsTotalNumber}
                        </p>
                        <p className="text-xs text-start text-neutral-600 ">
                          {subCategory.subCategoryLabel}
                        </p>
                      </div>
                    ))} */}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col items-center justify-center  w-full mx-auto pb-10">
        <Text
          text="Vous avez une question?"
          as="h3"
          className="text-lg font-bold text-center text-neutral-700 mt-12"
        />
        <a
          href={'/contact'}
          target="_blank"
          className=" text-sm lg:text-sm xl:text-base text-center underline text-neutral-700 mt-2 "
        >
          Contactez-nous
        </a>
        <div className="flex text-neutral-700 flex-col items-center ">
          <span className=" flex flex-col items-center text-center">
            <span className="text-sm my-2 font-light italic">Ou</span> Veuillez
            contacter le
            <span className="flex items-center gap-x-1 mt-1 font-bold text-stone-600 ">
              <HiPhone size={16} className="mt-[1px]" />
              +216 95 256 201{' '}
            </span>
          </span>
        </div>
      </div>
    </>
  );
};
